<template>
  <v-app id="inspire" class="compact">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm10 md8>
            <v-card class="elevation-12">
              <v-toolbar dark color="green lighten-1">
                <v-toolbar-title>PRISTUPNICA</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form id="formRegister" method="POST" @submit.prevent="handleSubmit" ref="form">
                  <v-sheet class="text-xs-right pt-2 pb-2 pl-2 pr-2 body-2 mb-2 font-weight-bold" color="white">
                    za učlanjenje u Hrvatski ogranak Međunarodnog vijeća za velike elektroenergetske sustave - CIGRÉ
                  </v-sheet>
                  <v-sheet class="text-xs-right pt-2 pb-2 pl-2 pr-2 mb-2 subheading white--text" color="blue lighten-1">INDIVIDUALNI ČLAN</v-sheet>

                  <v-text-field
                    v-model="formdata.name"
                    prepend-icon="person"
                    label="Ime i prezime"
                    type="text"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="formdata.oib"
                    prepend-icon="mdi-account-card-details-outline"
                    label="OIB"
                    mask="###########"
                    type="text"
                    :rules="oibRules"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="formdata.mbz"
                    prepend-icon="mdi-account-card-details-outline"
                    label="Matični broj znanstvenika"
                    type="text"
                  ></v-text-field>

                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="slide-x-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        label="Datum rođenja"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :rules="dateRules"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="formdata.date" :min="minDate" :max="maxDate" @input="menu2 = false"></v-date-picker>
                  </v-menu>
                  <v-text-field
                    v-model="formdata.birthplace"
                    prepend-icon="mdi-map-marker"
                    label="Mjesto rođenja"
                    type="text"
                    :rules="stringRules"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="formdata.title"
                    prepend-icon="account-settings"
                    label="Akademski naslov"
                    type="text"
                    :rules="stringRules"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="formdata.address"
                    prepend-icon="mdi-city"
                    label="Adresa privatna"
                    type="text"
                    :rules="stringNumRules"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="formdata.phone"
                    prepend-icon="mdi-phone-classic"
                    label="Telefon"
                    type="text"
                    :rules="phoneRules"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="formdata.mobile"
                    prepend-icon="mdi-cellphone-iphone"
                    label="Mobitel"
                    type="text"
                    :rules="cellRules"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="formdata.faculty"
                    prepend-icon="mdi-domain"
                    label="Zaposlen u (puni naslov tvrtke i organizacijske jedinice)"
                    type="text"
                    :rules="stringRules"
                    required
                  ></v-text-field>

                  <v-text-field v-model="formdata.aai" prepend-icon="mdi-at" label="E-mail" type="text" :rules="aaiRules" required></v-text-field>
                  <v-text-field
                    v-model="formdata.email"
                    prepend-icon="mdi-email"
                    label="Adresa na koju treba slati obavijesti iz HRO CIGRÉ"
                    type="text"
                    :rules="stringNumRules"
                    required
                  ></v-text-field>
                  <v-select
                    v-model="formdata.membertype"
                    :items="membertypeList"
                    prepend-icon="mdi-wallet-membership"
                    label="Vrsta članstva"
                    :rules="membertypeRules"
                    required
                  ></v-select>

                  <v-container grid-list-md text-xs-center fluid>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-sheet class="text-xs-left pt-2 pb-2 pl-2 pr-2 mb-2" color="green lighten-5" elevation="2">
                          Kao član HRO CIGRÉ zainteresiran sam za rad sljedećih studijskih odbora (najviše u dva):</v-sheet
                        >
                      </v-flex>
                      <v-flex xs12>
                        <v-sheet class="text-xs-left pt-2 pb-2 pl-2 pr-2 mb-2" color="transparent">Studijski odbori HRO CIGRÉ:</v-sheet>
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.a1"
                          class="ma-0 pa-0"
                          ref="a1"
                          name="a1"
                          :rules="[switchRules]"
                          label="A1 - Rotacijski električni strojevi"
                          color="success"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.c1"
                          class="ma-0 pa-0"
                          ref="c1"
                          name="c1"
                          :rules="[switchRules]"
                          label="C1 – Razvoj i ekonomija EES-a"
                          color="indigo"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.a2"
                          class="ma-0 pa-0"
                          ref="a2"
                          name="a2"
                          :rules="[switchRules]"
                          label="A2 – Energetski transformatori i prigušnice"
                          color="success"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.c2"
                          class="ma-0 pa-0"
                          ref="c2"
                          name="c2"
                          :rules="[switchRules]"
                          label="C2 – Pogon i vođenje EES-a"
                          color="indigo"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.a3"
                          class="ma-0 pa-0"
                          ref="a3"
                          name="a3"
                          :rules="[switchRules]"
                          label="A3 – Oprema za prijenos i distribuciju"
                          color="success"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.c3"
                          class="ma-0 pa-0"
                          ref="c3"
                          name="c3"
                          :rules="[switchRules]"
                          label="C3 – Utjecaj EES-a na okoliš"
                          color="indigo"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.b1"
                          class="ma-0 pa-0"
                          ref="b1"
                          name="b1"
                          :rules="[switchRules]"
                          label="B1 – Izolirani kabeli"
                          color="orange"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.c4"
                          class="ma-0 pa-0"
                          ref="c4"
                          name="c4"
                          :rules="[switchRules]"
                          label="C4 – Tehničke značajke EES-a"
                          color="indigo"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.b2"
                          class="ma-0 pa-0"
                          ref="b2"
                          name="b2"
                          :rules="[switchRules]"
                          label="B2 – Nadzemni vodov"
                          color="orange"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.c5"
                          class="ma-0 pa-0"
                          ref="c5"
                          name="c5"
                          :rules="[switchRules]"
                          label="C5 – Tržište električne energije i regulacija"
                          color="indigo"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.b3"
                          class="ma-0 pa-0"
                          ref="b3"
                          name="b3"
                          :rules="[switchRules]"
                          label="B3 – Rasklopna i slična elektromagnetska postrojenja"
                          color="orange"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.c6"
                          class="ma-0 pa-0"
                          ref="c6"
                          name="c6"
                          :rules="[switchRules]"
                          label="C6 – Aktivni distribucijski sustavi i distribuirani izvori energije"
                          color="indigo"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.b4"
                          class="ma-0 pa-0"
                          ref="b4"
                          name="b4"
                          :rules="[switchRules]"
                          label="B4 – Sustavi istosmjerne struje i energetska elektronika"
                          color="orange"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.d1"
                          class="ma-0 pa-0"
                          ref="d1"
                          name="d1"
                          :rules="[switchRules]"
                          label="D1 – Materijali i nove nadolazeće ispitne tehnike"
                          color="red"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.b5"
                          class="ma-0 pa-0"
                          ref="b5"
                          name="b5"
                          :rules="[switchRules]"
                          label="B5 – Zaštita i automatizacija"
                          color="orange"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-switch
                          v-model="formdata.d2"
                          class="ma-0 pa-0"
                          ref="d2"
                          name="d2"
                          :rules="[switchRules]"
                          label="D2 – Informacijski sustavi i telekomunikacije"
                          color="red"
                        />
                      </v-flex>
                      <v-flex xs12 v-if="formdata.membertype != 'Počasni članovi'">
                        <v-sheet class="text-xs-left pt-2 pb-2 pl-2 pr-2 mb-2" color="green lighten-5" elevation="2">
                          <v-checkbox
                            v-model="formdata.pay"
                            name="pay"
                            color="green"
                            label="Izjavljujem da ću redovito osobno plaćati individualnu članarinu u HRO CIGRÉ"
                          ></v-checkbox>
                        </v-sheet>
                      </v-flex>
                      <v-flex xs12 v-if="formdata.membertype != 'Počasni članovi'">
                        <v-sheet class="text-xs-left pt-2 pb-2 pl-2 pr-2 mb-2" color="green lighten-5" elevation="2">
                          <v-checkbox
                            v-model="formdata.payc"
                            name="payc"
                            color="green"
                            label="Izjavljujem da će mi tvrtka u kojoj sam zaposlen redovito plaćati individualnu članarinu u HRO CIGRÉ"
                          ></v-checkbox>
                        </v-sheet>
                      </v-flex>
                      <v-flex xs12>
                        <v-sheet class="text-xs-left pt-2 pb-2 pl-2 pr-2 mb-2" color="green lighten-5" elevation="2">
                          <v-checkbox
                            v-model="formdata.agree"
                            name="agree"
                            color="green"
                            label="Suglasan sam da se moji osobni podaci sukladno odredbama Zakona o zaštiti osobnih podataka mogu prikupljati, obrađivati i čuvati kod HRO CIGRÉ."
                          ></v-checkbox>
                        </v-sheet>
                      </v-flex>
                      <v-flex xs12>
                        <p class="font-weight-light font-italic">Napomena: Navedeni podaci traženi su na temelju Zakona o udrugama.</p>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import moment, { version } from "moment";
import axios from "axios";

export default {
  data: () => ({
    formdata: {
      name: "",
      oib: "",
      mbz: "",
      date: (() => {
        var d = new Date();
        d.setFullYear(d.getFullYear() - 14);
        return d.toISOString().substr(0, 10);
      })(),
      birthplace: "",
      title: "",
      address: "",
      phone: "",
      mobile: "",
      faculty: "",
      aai: "",
      email: "",
      membertype: "",
      a1: false,
      a2: false,
      a3: false,
      b1: false,
      b2: false,
      b3: false,
      b4: false,
      b5: false,
      c1: false,
      c2: false,
      c3: false,
      c4: false,
      c5: false,
      c6: false,
      d1: false,
      d2: false,
      pay: false,
      payc: false,
      agree: false,
    },
    menu2: false,
    alerterror: false,
    alertsuccess: false,
    alertloading: false,
    errortext: "",
    membertypeList: ["Redovni članovi", "Redovni članovi - mladi inženjeri", "Redovni članovi - umirovljenici", "Počasni članovi"],
    regvisible: true,
    minDate: moment().subtract(60, "years").toISOString().substr(0, 10),
    maxDate: moment().subtract(13, "years").toISOString().substr(0, 10),
    nameRules: [
      (v) => !!v || "Morate popuniti ovo polje",
      (v) => v.length <= 100 || "Maksimalni dozvoljeni broj znakova je 100",
      (v) => /^([A-Za-z.'ČčĆćŠšĐđŽžß-]{2,} ){1,4}([A-Za-z.'ČčĆćŠšĐđŽžß-]{2,})$/.test(v) || "Ime i prezime nisu ispravni",
    ],
    oibRules: [
      (v) => !!v || "Morate popuniti ovo polje",
      (v) => v.length == 11 || "OIB mora sadržavati 11 znamenki",
      (v) => {
        v = v.toString();
        if (v.length != 11) return false;

        var b = parseInt(version, 10);
        if (isNaN(b)) return false;

        var a = 10;
        for (var i = 0; i < 10; i++) {
          a = a + parseInt(v.substr(i, 1), 10);
          a = a % 10;
          if (a == 0) a = 10;
          a *= 2;
          a = a % 11;
        }
        var kontrolni = 11 - a;
        if (kontrolni == 10) kontrolni = 0;

        return kontrolni == parseInt(v.substr(10, 1)) || "OIB nije ispravan";
      },
    ],
    dateRules: [
      (v) => !!v || "Morate popuniti ovo polje",
      (v) => moment(v, "DD.MM.YYYY.").isBefore(moment().subtract(15, "years")) || "Provjerite podatak o datumu rođenja",
    ],
    aaiRules: [
      (v) => !!v || "Morate popuniti ovo polje",
      (v) => v.length <= 100 || "Maksimalni dozvoljeni broj znakova je 100",
      (v) => /^([a-zA-Z0-9-_]+|([a-zA-Z0-9-_]+\.){1,2}[a-zA-Z0-9-_]+)@([a-zA-Z0-9-_]+\.){1,3}[a-z]{2,}$/.test(v) || "E-mail nije ispravan",
    ],
    stringRules: [
      (v) => !!v || "Morate popuniti ovo polje",
      (v) => v.length <= 100 || "Maksimalni dozvoljeni broj znakova je 100",
      (v) =>
        /^(([A-Za-z.'ČčĆćŠšĐđŽžß,/-]+ ){1,}[A-Za-z.'ČčĆćŠšĐđŽžß,/-]+|[A-Za-z.'ČčĆćŠšĐđŽžß,/-]+)$/.test(v) ||
        "Nedozvoljeni znakovi u tekstu ili višak razmaka",
    ],
    stringNumRules: [
      (v) => !!v || "Morate popuniti ovo polje",
      (v) => v.length <= 100 || "Maksimalni dozvoljeni broj znakova je 100",
      (v) =>
        /^(([A-Za-z0-9.'ČčĆćŠšĐđŽžß,/-]+ ){1,}[A-Za-z0-9.'ČčĆćŠšĐđŽžß,/-]+|[A-Za-z0-9.'ČčĆćŠšĐđŽžß,/-]+)$/.test(v) ||
        "Nedozvoljeni znakovi u tekstu ili višak razmaka",
    ],
    phoneRules: [
      (v) => !!v || "Morate popuniti ovo polje",
      (v) => v.length <= 16 || "Maksimalni dozvoljeni broj znakova je 16",
      (v) =>
        /^\+385 (1|49|44|47|42|48|43|40|51|53|52|33|34|35|31|32|23|22|21|20) [0-9]{3,4}-[0-9]{3}$/.test(v) ||
        "Neispravan broj telefona. Koristite format: +385 55 5555-555. Pozivni broj mora biti važeći.",
    ],
    cellRules: [
      (v) => !!v || "Morate popuniti ovo polje",
      (v) => v.length <= 17 || "Maksimalni dozvoljeni broj znakova je 17",
      (v) =>
        /^\+385 (91|92|95|976|977|979|98|99) [0-9]{3,4}-[0-9]{3}$/.test(v) ||
        "Neispravan broj mobitela. Koristite format: +385 55 5555-555. Pozivni broj mora biti važeći.",
    ],
    membertypeRules: [(v) => !!v || "Morate odabrati vrstu članstva"],
  }),
  props: {
    source: String,
  },

  computed: {
    computedDateFormatted() {
      return this.formdata.date ? moment(this.formdata.date).format("DD.MM.YYYY.") : "";
    },
  },

  methods: {
    countSwitch() {
      var cnt = 0;
      if (this.formdata.a1) cnt++;
      if (this.formdata.a2) cnt++;
      if (this.formdata.a3) cnt++;
      if (this.formdata.b1) cnt++;
      if (this.formdata.b2) cnt++;
      if (this.formdata.b3) cnt++;
      if (this.formdata.b4) cnt++;
      if (this.formdata.b5) cnt++;
      if (this.formdata.c1) cnt++;
      if (this.formdata.c2) cnt++;
      if (this.formdata.c3) cnt++;
      if (this.formdata.c4) cnt++;
      if (this.formdata.c5) cnt++;
      if (this.formdata.c6) cnt++;
      if (this.formdata.d1) cnt++;
      if (this.formdata.d2) cnt++;
      return cnt;
    },
    handleSubmit() {
      this.alertsuccess = false;
      this.alerterror = false;
      this.alertloading = true;
      if (!this.formdata.agree) {
        this.errortext = "Prijava nije uspješna. Za uspješnu prijavu morate dati suglasnost za osobne podatke.";
        this.alertsuccess = false;
        this.alertloading = false;
        this.alerterror = true;
      } else if (this.formdata.membertype != "Počasni članovi" && !(this.formdata.pay || this.formdata.payc)) {
        this.errortext = "Prijava nije uspješna. Za uspješnu prijavu morate dati izjavu o plaćanju članarine.";
        this.alertsuccess = false;
        this.alertloading = false;
        this.alerterror = true;
      } else if (this.countSwitch() == 0) {
        this.errortext = "Prijava nije uspješna. Morate odabrati barem jedan studijski odbor.";
        this.alertsuccess = false;
        this.alertloading = false;
        this.alerterror = true;
      } else if (!this.$refs.form.validate()) {
        this.errortext = "Prijava nije uspješna. Provjerite polja koja nisu ispravna.";
        this.alertsuccess = false;
        this.alertloading = false;
        this.alerterror = true;
      } else {
        let vm = this;
        // axios.post('http://localhost:8081/cigreform/api/registerind.php',this.formdata,
        axios
          .post("/api/registerind.php", this.formdata)
          .then(function (response) {
            if (response.data === "REGOK") {
              vm.alerterror = false;
              vm.alertloading = false;
              vm.alertsuccess = true;
              vm.formdata.agree = false;
              vm.regvisible = false;
            } else {
              vm.errortext = "Greška prilikom prijave! Pokušajte ponovno kasnije.";
              vm.alertsuccess = false;
              vm.alertloading = false;
              vm.alerterror = true;
            }
          })
          .catch(function () {
            vm.errortext = "Greška prilikom prijave! Pokušajte ponovno kasnije.";
            vm.alertsuccess = false;
            vm.alertloading = false;
            vm.alerterror = true;
            // console.log(error);
          });
      }
    },
    switchRules() {
      // count selected options
      var cnt = this.countSwitch();
      if (cnt > 2) {
        if (this.formdata.a1) this.formdata.a1 = false;
        else if (this.formdata.a2) this.formdata.a2 = false;
        else if (this.formdata.a3) this.formdata.a3 = false;
        else if (this.formdata.b1) this.formdata.b1 = false;
        else if (this.formdata.b2) this.formdata.b2 = false;
        else if (this.formdata.b3) this.formdata.b3 = false;
        else if (this.formdata.b4) this.formdata.b4 = false;
        else if (this.formdata.b5) this.formdata.b5 = false;
        else if (this.formdata.c1) this.formdata.c1 = false;
        else if (this.formdata.c2) this.formdata.c2 = false;
        else if (this.formdata.c3) this.formdata.c3 = false;
        else if (this.formdata.c4) this.formdata.c4 = false;
        else if (this.formdata.c5) this.formdata.c5 = false;
        else if (this.formdata.c6) this.formdata.c6 = false;
        else if (this.formdata.d1) this.formdata.d1 = false;
        else if (this.formdata.d2) this.formdata.d2 = false;
      }
      return true;
    },
    getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
  },
  mounted() {
    this.formdata.name = this.getParameterByName("Name");
    this.formdata.oib = this.getParameterByName("Oib");
    this.formdata.mbz = this.getParameterByName("Mbz");
    this.formdata.date = this.getParameterByName("Date");
    this.formdata.birthplace = this.getParameterByName("Birthplace");
    this.formdata.title = this.getParameterByName("Title");
    this.formdata.address = this.getParameterByName("Address");
    this.formdata.phone = this.getParameterByName("Phone");
    this.formdata.mobile = this.getParameterByName("Mobile");
    this.formdata.faculty = this.getParameterByName("Faculty");
    this.formdata.aai = this.getParameterByName("Aai");
    this.formdata.email = this.getParameterByName("Email");
    this.formdata.membertype = this.getParameterByName("MemberType");
    this.formdata.a1 = this.getParameterByName("A1") === "1";
    this.formdata.a2 = this.getParameterByName("A2") === "1";
    this.formdata.a3 = this.getParameterByName("A3") === "1";
    this.formdata.b1 = this.getParameterByName("B1") === "1";
    this.formdata.b2 = this.getParameterByName("B2") === "1";
    this.formdata.b3 = this.getParameterByName("B3") === "1";
    this.formdata.b4 = this.getParameterByName("B4") === "1";
    this.formdata.b5 = this.getParameterByName("B5") === "1";
    this.formdata.c1 = this.getParameterByName("C1") === "1";
    this.formdata.c2 = this.getParameterByName("C2") === "1";
    this.formdata.c3 = this.getParameterByName("C3") === "1";
    this.formdata.c4 = this.getParameterByName("C4") === "1";
    this.formdata.c5 = this.getParameterByName("C5") === "1";
    this.formdata.c6 = this.getParameterByName("C6") === "1";
    this.formdata.d1 = this.getParameterByName("D1") === "1";
    this.formdata.d2 = this.getParameterByName("D2") === "1";
    this.formdata.pay = this.getParameterByName("Pay") === "1";
    this.formdata.payc = this.getParameterByName("PayC") === "1";
    this.formdata.agree = true;
  },
};
</script>

<style scoped>
.compact {
  zoom: 0.45;
  -moz-transform: scale(0.45);
  -moz-transform-origin: 50% 0;
}
</style>
